import { chakraUiTheme } from '@everfi/design-system';
var videoPlayerSx = {
  '.video-react': {
    fontFamily: 'inherit !important',
    background: 'transparent !important'
  },
  '.video-react-video': {
    borderRadius: "0px 0px .75rem .75rem !important"
  },
  '.video-react-control-bar': {
    height: '4em !important',
    borderRadius: "0px 0px ".concat(chakraUiTheme.everfi.BorderRadiiLg, " ").concat(chakraUiTheme.everfi.BorderRadiiLg, " !important"),
    bg: 'black !important'
  },
  '.video-react-playback-rate': {
    display: 'none !important'
  },
  '.video-react-control:before': {
    fontSize: '2em !important',
    lineHeight: '2 !important'
  },
  '.video-react-play-progress': {
    backgroundColor: '#0D9C94 !important',
    height: '4px !important'
  },
  '.video-react .video-react-button.video-react-big-play-button': {
    borderRadius: '50%',
    borderWidth: '1px',
    height: '52px',
    width: '52px',
    backgroundColor: '#fff !important',
    color: '#000 !important',
    lineHeight: '1.7 !important'
  }
};
export { videoPlayerSx };